import React from 'react'
import { createRoot } from 'react-dom/client'
import { ChakraProvider } from '@chakra-ui/react'
import { BrowserRouter } from 'react-router-dom'
import { I18nextProvider } from 'react-i18next'
import { system } from './theme'
import App from './App'
import i18n from './i18n'
import './index.css'

const RootWrapper = ({ children }: { children: React.ReactNode }) => <>{children}</>

createRoot(document.getElementById('root')!).render(
  <RootWrapper>
    <I18nextProvider i18n={i18n}>
      <ChakraProvider value={system}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </ChakraProvider>
    </I18nextProvider>
  </RootWrapper>,
)
